"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateUtils = void 0;
const constants_1 = require("./constants");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const humanizeDuration = require('humanize-duration');
// ! Fixing: TypeError: Cannot read properties of undefined (reading 'locale')
// eslint-disable-next-line @typescript-eslint/no-var-requires
const moment = require('moment-business-days');
// ! Fixing date-holidays.default is not a constructor
// eslint-disable-next-line @typescript-eslint/no-var-requires
const Holidays = require('date-holidays');
moment.locale('fr');
const defaultHumanizeDurationConfig = {
    language: 'fr',
    units: ['y', 'mo'],
    round: true,
    conjunction: ' et ',
    serialComma: false,
};
function getHumanizer(config) {
    return humanizeDuration.humanizer({
        ...defaultHumanizeDurationConfig,
        ...config,
    });
}
function getThreeYearsOfFrenchHolidays() {
    const hd = new Holidays('FR');
    const currentYear = new Date().getFullYear();
    const nextThreeYears = Array.from({ length: 3 }, (_, index) => currentYear + index);
    return nextThreeYears.reduce((holidaysList, year) => {
        const holidays = hd.getHolidays(year);
        const publicDayHolidays = holidays
            .filter(holiday => holiday.type === 'public')
            .map(holiday => {
            const [date] = holiday.date.split(' ');
            return date;
        });
        return [...holidaysList, ...publicDayHolidays];
    }, []);
}
moment.updateLocale('fr', {
    holidays: getThreeYearsOfFrenchHolidays(),
    holidayFormat: 'YYYY-MM-DD',
});
exports.dateUtils = {
    now() {
        return moment();
    },
    getDateDuration(diffDate, type = 'milliseconds') {
        return moment.duration(diffDate, type);
    },
    isDateSame(date1, date2, type) {
        return moment(date1).isSame(moment(date2), type);
    },
    isDate(date, format = undefined) {
        if (date === undefined || date === null) {
            return false;
        }
        try {
            return moment(date, format).isValid();
        }
        catch (err) {
            console.error(err);
            return false;
        }
    },
    diffDate(date1, date2, unit = null) {
        return this.createDate(date1).diff(this.createDate(date2), unit);
    },
    createDate(date, utc = false, format = undefined) {
        if (!this.isDate(date, format)) {
            console.error(`Invalid param data '${date}' - Cannot be converted to date`);
            return null;
        }
        return utc ? moment.utc(date, format) : moment(date, format);
    },
    formatDate(date, format, fallback = true) {
        if (this.isDate(date)) {
            return moment(date).format(format);
        }
        if (fallback) {
            return constants_1.DEFAULT_STR;
        }
        return null;
    },
    humanizeDuration(duration, config = {}) {
        const humanizer = getHumanizer(config);
        return humanizer(duration);
    },
    getTimestamp(date) {
        return this.isDate(date) ? moment.utc(date).valueOf() : null;
    },
    getTimestampSecond(date) {
        return this.isDate(date) ? moment(date).unix() : null;
    },
    isDateBetween(date, dateBegin, dateEnd, param, inclusivity) {
        return moment(date).isBetween(moment(dateBegin), moment(dateEnd), param, inclusivity);
    },
    isDateAfter(date, otherDate) {
        return moment(date).isAfter(otherDate);
    },
    isDateBefore(date, otherDate) {
        return moment(date).isBefore(otherDate);
    },
    isBusinessDay(date) {
        return moment(date).isBusinessDay();
    },
    prevBusinessDay(date) {
        return moment(date).prevBusinessDay();
    },
    nextBusinessDay(date) {
        return moment(date).nextBusinessDay();
    },
    businessDiff(date, otherDate) {
        return moment(date).businessDiff(this.createDate(otherDate));
    },
    dateStartOf(date, unit, utc = false) {
        return utc ? moment.utc(date).startOf(unit) : moment(date).startOf(unit);
    },
    dateEndOf(date, unit, utc = false) {
        return utc ? moment.utc(date).endOf(unit) : moment(date).endOf(unit);
    },
    dateAdd(date, nb, unit) {
        if (unit === 'businessDays') {
            return moment(date).businessAdd(nb);
        }
        return moment(date).add(nb, unit);
    },
    dateSubtract(date, nb, unit) {
        if (unit === 'businessDays') {
            return moment(date).businessSubtract(nb);
        }
        return moment(date).subtract(nb, unit);
    },
};
//# sourceMappingURL=date.js.map